const paymentGridListItemHeaders = document.querySelectorAll('.payment-grid-list-item > header');

paymentGridListItemHeaders.forEach(function(header){
	header.addEventListener('click', function(e){
		const body = this.nextElementSibling;
		const maxHeight = body.style.maxHeight;
		if(maxHeight){
			body.style.maxHeight = '';
			header.getElementsByTagName('use')[0].href.baseVal = '#gs-icon-payment-methods-caret-down'
		}else{
			paymentGridListItemHeaders.forEach(function(aHeader){
				const closeBody = aHeader.nextElementSibling;
				closeBody.style.maxHeight = '';
				aHeader.getElementsByTagName('use')[0].href.baseVal = '#gs-icon-payment-methods-caret-down'
			});
			const maxHeight = body.scrollHeight;
			body.style.maxHeight = `${maxHeight}px`;
			header.getElementsByTagName('use')[0].href.baseVal = '#gs-icon-payment-methods-caret-up'
		}
	});
})


const searchBox = document.getElementById('help-and-support-search');
const faqCategories = document.querySelectorAll('.payment-grid-filter-body > a');
searchBox.addEventListener('input', function(e){
	const value = e.target.value.toLocaleLowerCase();
	Object.values(faqCategories).forEach(faqCategory => {
		if(faqCategory.innerText.toLocaleLowerCase().indexOf(value) === -1){
			faqCategory.style.display = 'none';
		}
		else{
			faqCategory.style.display = '';
		}
	});
});
